export const DashboardAccountSettings = () => {
  return (
    <svg
      width="105"
      height="122"
      viewBox="0 0 105 122"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.6709 120.483C38.1862 120.56 38.7146 120.6 39.2529 120.6H41.1504V122H39.2529L38.9434 121.996C38.4419 121.983 37.9482 121.939 37.4639 121.866L37.6709 120.483Z"
        fill="#E2E6EB"
      />
      <path d="M47.791 122H43.9961V120.6H47.791V122Z" fill="#E2E6EB" />
      <path d="M54.4316 122H50.6367V120.6H54.4316V122Z" fill="#E2E6EB" />
      <path d="M61.0723 122H57.2783V120.6H61.0723V122Z" fill="#E2E6EB" />
      <path d="M67.7139 122H63.9189V120.6H67.7139V122Z" fill="#E2E6EB" />
      <path d="M74.3545 122H70.5596V120.6H74.3545V122Z" fill="#E2E6EB" />
      <path d="M80.9951 122H77.2002V120.6H80.9951V122Z" fill="#E2E6EB" />
      <path d="M87.6357 122H83.8408V120.6H87.6357V122Z" fill="#E2E6EB" />
      <path
        d="M94.0645 121.175L94.1318 121.622L94.167 121.866C93.5838 121.953 92.9864 122 92.3789 122H90.4824V120.6H92.3789C92.9173 120.6 93.4466 120.56 93.9619 120.483L94.0645 121.175Z"
        fill="#E2E6EB"
      />
      <path
        d="M32.9121 118.494C33.6642 119.057 34.4926 119.522 35.3789 119.87L34.8682 121.169C33.7434 120.727 32.7017 120.122 31.7725 119.38L32.4795 118.494H32.9121Z"
        fill="#E2E6EB"
      />
      <path
        d="M99.8594 119.38C98.9299 120.122 97.8878 120.727 96.7627 121.169L96.2529 119.87C97.2457 119.48 98.1668 118.944 98.9883 118.288L99.8594 119.38Z"
        fill="#E2E6EB"
      />
      <path
        d="M103.549 114.384C103.107 115.509 102.501 116.55 101.759 117.479L100.668 116.608C101.324 115.787 101.86 114.867 102.25 113.874L103.549 114.384Z"
        fill="#E2E6EB"
      />
      <path
        d="M104.379 110L104.375 110.31C104.362 110.811 104.318 111.304 104.246 111.788L102.862 111.582C102.939 111.067 102.979 110.538 102.979 110V108H104.379V110Z"
        fill="#E2E6EB"
      />
      <path d="M104.379 105H102.979V101H104.379V105Z" fill="#E2E6EB" />
      <path d="M104.379 98H102.979V94H104.379V98Z" fill="#E2E6EB" />
      <path d="M104.379 91H102.979V87H104.379V91Z" fill="#E2E6EB" />
      <path d="M104.379 84H102.979V80H104.379V84Z" fill="#E2E6EB" />
      <path d="M104.379 77H102.979V73H104.379V77Z" fill="#E2E6EB" />
      <path d="M104.379 70H102.979V66H104.379V70Z" fill="#E2E6EB" />
      <path d="M104.379 63H102.979V59H104.379V63Z" fill="#E2E6EB" />
      <path d="M104.379 56H102.979V52H104.379V56Z" fill="#E2E6EB" />
      <path
        d="M28.6533 54.1553C28.1842 54.1608 27.7156 54.2081 27.2529 54.2959V52H28.6533V54.1553Z"
        fill="#E2E6EB"
      />
      <path d="M28.6533 49H27.2529V45H28.6533V49Z" fill="#E2E6EB" />
      <path d="M104.379 49H102.979V45H104.379V49Z" fill="#E2E6EB" />
      <path d="M28.6533 42H27.2529V38H28.6533V42Z" fill="#E2E6EB" />
      <path d="M104.379 42H102.979V38H104.379V42Z" fill="#E2E6EB" />
      <path d="M28.6533 35H27.2529V31H28.6533V35Z" fill="#E2E6EB" />
      <path d="M104.379 35H102.979V31H104.379V35Z" fill="#E2E6EB" />
      <path d="M28.6533 28H27.2529V24H28.6533V28Z" fill="#E2E6EB" />
      <path d="M104.379 28H102.979V24H104.379V28Z" fill="#E2E6EB" />
      <path d="M28.6533 21H27.2529V17H28.6533V21Z" fill="#E2E6EB" />
      <path d="M104.379 21H102.979V17H104.379V21Z" fill="#E2E6EB" />
      <path
        d="M28.7695 10.418C28.6925 10.9333 28.6533 11.4616 28.6533 12V14H27.2529V12C27.2529 11.392 27.2985 10.7946 27.3857 10.2109L28.7695 10.418Z"
        fill="#E2E6EB"
      />
      <path
        d="M104.246 10.2109C104.333 10.7946 104.379 11.392 104.379 12V14H102.979V12C102.979 11.4616 102.939 10.9333 102.862 10.418L104.246 10.2109Z"
        fill="#E2E6EB"
      />
      <path
        d="M30.9648 5.3916C30.3089 6.21303 29.7728 7.13333 29.3828 8.12598L28.083 7.61523C28.5249 6.49052 29.1301 5.44872 29.8721 4.51953L30.9648 5.3916Z"
        fill="#E2E6EB"
      />
      <path
        d="M101.759 4.51953C102.501 5.44885 103.107 6.49031 103.549 7.61523L102.25 8.12598C101.86 7.13335 101.324 6.21303 100.668 5.3916L101.759 4.51953Z"
        fill="#E2E6EB"
      />
      <path
        d="M35.3789 2.12988C34.3863 2.51983 33.466 3.05602 32.6445 3.71191L31.7725 2.61914C32.7016 1.87724 33.7435 1.27192 34.8682 0.830078L35.3789 2.12988Z"
        fill="#E2E6EB"
      />
      <path
        d="M96.7627 0.830078C97.8877 1.27193 98.9299 1.87706 99.8594 2.61914L99.6299 2.9082L98.9883 3.71191C98.1668 3.05593 97.2457 2.51986 96.2529 2.12988L96.7627 0.830078Z"
        fill="#E2E6EB"
      />
      <path
        d="M41.1504 1.40039H39.2529C38.7146 1.40039 38.1862 1.43959 37.6709 1.5166L37.4639 0.132812C38.0475 0.0455776 38.645 3.01726e-08 39.2529 0H41.1504V1.40039Z"
        fill="#E2E6EB"
      />
      <path
        d="M92.3789 0C92.9863 9.18145e-06 93.5838 0.0457065 94.167 0.132812L94.0654 0.825195L94.0645 0.824219L93.9619 1.5166C93.4466 1.43957 92.9173 1.4004 92.3789 1.40039H90.4824V0H92.3789Z"
        fill="#E2E6EB"
      />
      <path d="M47.791 1.40039H43.9961V0H47.791V1.40039Z" fill="#E2E6EB" />
      <path d="M54.4316 1.40039H50.6367V0H54.4316V1.40039Z" fill="#E2E6EB" />
      <path d="M61.0723 1.40039H57.2783V0H61.0723V1.40039Z" fill="#E2E6EB" />
      <path d="M67.7139 1.40039H63.9189V0H67.7139V1.40039Z" fill="#E2E6EB" />
      <path d="M74.3545 1.40039H70.5596V0H74.3545V1.40039Z" fill="#E2E6EB" />
      <path d="M80.9951 1.40039H77.2002V0H80.9951V1.40039Z" fill="#E2E6EB" />
      <path d="M87.6357 1.40039H83.8408V0H87.6357V1.40039Z" fill="#E2E6EB" />
      <path
        d="M49.4941 117.494V118.494H8V117.494H49.4941ZM56.4941 110.494V78.8538C56.4941 76.7348 55.5344 74.7294 53.8838 73.4006L33.1357 56.7014C30.5732 54.6391 26.9209 54.6391 24.3584 56.7014L3.61133 73.4006C1.96044 74.7294 1 76.7346 1 78.8538V110.494C1.0001 114.36 4.13407 117.494 8 117.494V118.494L7.58789 118.484C3.49737 118.276 0.21792 114.996 0.0107422 110.906L0 110.494V78.8538C0 76.5832 0.964563 74.4272 2.63965 72.9153L2.98438 72.6213L23.7314 55.9221C26.6601 53.5652 30.8351 53.565 33.7637 55.9221L54.5107 72.6213C56.3973 74.1399 57.4941 76.4319 57.4941 78.8538V110.494L57.4834 110.906C57.2762 114.996 53.9968 118.276 49.9062 118.484L49.4941 118.494V117.494C53.3601 117.494 56.494 114.36 56.4941 110.494Z"
        fill="#E2E6EB"
      />
      <path
        d="M13.7079 100.39C13.6999 96.433 16.9008 93.2191 20.8573 93.2111L36.4311 93.1797C40.3876 93.1717 43.6015 96.3726 43.6095 100.329C43.6175 104.286 40.4165 107.5 36.46 107.507L20.8863 107.539C16.9298 107.547 13.7159 104.346 13.7079 100.39Z"
        fill="white"
      />
      <path
        d="M43.6095 100.329C43.6175 104.286 40.4165 107.5 36.46 107.507L20.8863 107.539C16.9298 107.547 13.7159 104.346 13.7079 100.39L13.7183 100.711C13.9166 104.021 17.0518 106.646 20.8849 106.639L36.4585 106.607C40.4148 106.599 43.6163 103.788 43.6095 100.329Z"
        fill="#E2E6EB"
      />
      <path
        d="M30.5274 100.356C30.5215 97.4314 32.8874 95.0559 35.8118 95.05C38.7362 95.0441 41.1117 97.41 41.1176 100.334C41.1235 103.259 38.7576 105.634 35.8332 105.64C32.9088 105.646 30.5334 103.28 30.5274 100.356Z"
        fill="#D8E5FF"
      />
      <path
        d="M41.1176 100.334C41.1235 103.259 38.7576 105.634 35.8332 105.64C32.9088 105.646 30.5334 103.28 30.5274 100.356L30.5349 100.598C30.6816 103.081 32.999 105.052 35.832 105.046C38.7563 105.041 41.1228 102.931 41.1176 100.334Z"
        fill="#99BCFF"
      />
      <path
        d="M13.6722 82.9492C13.6642 78.9927 16.8651 75.7788 20.8216 75.7708L36.3954 75.7393C40.3519 75.7313 43.5658 78.9323 43.5738 82.8888C43.5818 86.8453 40.3808 90.0592 36.4243 90.0672L20.8506 90.0987C16.8941 90.1067 13.6802 86.9057 13.6722 82.9492Z"
        fill="#F4F6F8"
      />
      <path
        d="M43.5738 82.8888C43.5818 86.8453 40.3808 90.0592 36.4243 90.0672L20.8506 90.0987C16.8941 90.1067 13.6802 86.9057 13.6722 82.9492L13.6825 83.271C13.8808 86.5806 17.016 89.2062 20.8491 89.1984L36.4227 89.167C40.379 89.1589 43.5806 86.3482 43.5738 82.8888Z"
        fill="#E2E6EB"
      />
      <path
        d="M15.5409 82.9456C15.535 80.0213 17.9009 77.6458 20.8253 77.6399C23.7497 77.634 26.1251 79.9999 26.1311 82.9242C26.137 85.8486 23.7711 88.2241 20.8467 88.23C17.9223 88.2359 15.5468 85.87 15.5409 82.9456Z"
        fill="white"
      />
      <path
        d="M26.1311 82.9242C26.137 85.8486 23.7711 88.2241 20.8467 88.23C17.9223 88.2359 15.5468 85.87 15.5409 82.9456L15.5483 83.1882C15.6951 85.6815 18.0125 87.6595 20.8455 87.6537C23.7698 87.6478 26.1363 85.5305 26.1311 82.9242Z"
        fill="#BAC6D1"
      />
      <path
        d="M45.294 15.9436C45.294 14.839 46.1894 13.9436 47.294 13.9436H57.317C58.4216 13.9436 59.317 14.839 59.317 15.9436V25.9666C59.317 27.0712 58.4216 27.9666 57.317 27.9666H47.294C46.1894 27.9666 45.294 27.0712 45.294 25.9666V15.9436Z"
        fill="#D8E5FF"
      />
      <path
        d="M59.3106 26.1038C59.2401 27.1441 58.3752 27.9664 57.317 27.9666H47.294C46.1894 27.9666 45.294 27.0712 45.294 25.9666L45.3047 26.1038C45.4073 26.7794 46.2586 27.3069 47.294 27.3069H57.3174C58.4216 27.3067 59.3166 26.7063 59.317 25.9666C59.317 26.0125 59.3129 26.0584 59.3106 26.1038Z"
        fill="#99BCFF"
      />
      <path
        d="M73.34 15.9436C73.34 14.839 74.2354 13.9436 75.34 13.9436H85.363C86.4675 13.9436 87.363 14.839 87.363 15.9436V25.9666C87.363 27.0712 86.4675 27.9666 85.363 27.9666H75.34C74.2354 27.9666 73.34 27.0712 73.34 25.9666V15.9436Z"
        fill="#D8E5FF"
      />
      <path
        d="M87.3566 26.1038C87.286 27.1441 86.4212 27.9664 85.363 27.9666H75.34C74.2354 27.9666 73.34 27.0712 73.34 25.9666L73.3507 26.1038C73.4533 26.7794 74.3046 27.3069 75.34 27.3069H85.3634C86.4676 27.3067 87.3626 26.7063 87.363 25.9666C87.363 26.0125 87.3589 26.0584 87.3566 26.1038Z"
        fill="#99BCFF"
      />
      <path
        d="M45.294 42.59C45.294 41.4854 46.1894 40.59 47.294 40.59H57.317C58.4216 40.59 59.317 41.4854 59.317 42.59V52.613C59.317 53.7175 58.4216 54.613 57.317 54.613H47.294C46.1894 54.613 45.294 53.7175 45.294 52.613V42.59Z"
        fill="#D8E5FF"
      />
      <path
        d="M59.3106 52.7501C59.2401 53.7905 58.3752 54.6127 57.317 54.613H47.294C46.1894 54.613 45.294 53.7175 45.294 52.613L45.3047 52.7501C45.4073 53.4257 46.2586 53.9533 47.294 53.9533H57.3174C58.4216 53.9531 59.3166 53.3527 59.317 52.613C59.317 52.6589 59.3129 52.7048 59.3106 52.7501Z"
        fill="#99BCFF"
      />
      <path
        d="M73.34 42.5886C73.34 41.484 74.2354 40.5886 75.34 40.5886H85.363C86.4675 40.5886 87.363 41.484 87.363 42.5886V52.6116C87.363 53.7161 86.4675 54.6116 85.363 54.6116H75.34C74.2354 54.6116 73.34 53.7161 73.34 52.6116V42.5886Z"
        fill="#D8E5FF"
      />
      <path
        d="M87.3566 52.7487C87.286 53.7891 86.4212 54.6113 85.363 54.6116H75.34C74.2354 54.6116 73.34 53.7161 73.34 52.6116L73.3507 52.7487C73.4533 53.4243 74.3046 53.9519 75.34 53.9519H85.3634C86.4676 53.9517 87.3626 53.3513 87.363 52.6116C87.363 52.6575 87.3589 52.7034 87.3566 52.7487Z"
        fill="#99BCFF"
      />
      <path
        d="M73.34 69.2254C73.34 68.1209 74.2354 67.2254 75.34 67.2254H85.363C86.4675 67.2254 87.363 68.1209 87.363 69.2254V79.2484C87.363 80.353 86.4675 81.2484 85.363 81.2484H75.34C74.2354 81.2484 73.34 80.353 73.34 79.2484V69.2254Z"
        fill="#D8E5FF"
      />
      <path
        d="M87.3566 79.3856C87.286 80.426 86.4212 81.2482 85.363 81.2484H75.34C74.2354 81.2484 73.34 80.353 73.34 79.2484L73.3507 79.3856C73.4533 80.0612 74.3046 80.5887 75.34 80.5887H85.3634C86.4676 80.5886 87.3626 79.9882 87.363 79.2484C87.363 79.2943 87.3589 79.3403 87.3566 79.3856Z"
        fill="#99BCFF"
      />
      <path
        d="M73.34 95.9541C73.34 94.8495 74.2354 93.9541 75.34 93.9541H85.363C86.4675 93.9541 87.363 94.8495 87.363 95.9541V105.977C87.363 107.082 86.4675 107.977 85.363 107.977H75.34C74.2354 107.977 73.34 107.082 73.34 105.977V95.9541Z"
        fill="#D8E5FF"
      />
      <path
        d="M87.3566 106.114C87.286 107.155 86.4212 107.977 85.363 107.977H75.34C74.2354 107.977 73.34 107.082 73.34 105.977L73.3507 106.114C73.4533 106.79 74.3046 107.317 75.34 107.317H85.3634C86.4676 107.317 87.3626 106.717 87.363 105.977C87.363 106.023 87.3589 106.069 87.3566 106.114Z"
        fill="#99BCFF"
      />
    </svg>
  );
};
